import { render, staticRenderFns } from "./VacacionesEmpleados.vue?vue&type=template&id=3b52a358"
import script from "./VacacionesEmpleados.vue?vue&type=script&lang=js"
export * from "./VacacionesEmpleados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports